import React, { useEffect, useState } from 'react';
import api from '../services';
import imgs from '../assets/image.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import { IMG_BASE_URL } from '../Helpers';
import 'swiper/css';
import 'swiper/css/effect-fade';
export default function HomePageHeader() {
    const [bannerImage, setBannerImage] = useState([]);
    const fetchBannerImages = async () => {
        try {
            const b = await api("GET", "header-banner");
            setBannerImage(b);
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        if (bannerImage.length === 0) {
            fetchBannerImages();
        }
    }, []);
    return (
        <>
            <header className="bg-dark py-5 bg-cherry-red">
                <div className="container px-5">
                    <div className="row gx-5 align-items-center justify-content-center">
                        <div className="col-lg-8 col-xl-6 col-xxl-6">
                            <div className="my-5 text-center text-xl-start">
                                <h1 className="display-5 fw-bolder text-white mb-2 pb-4">പുസ്തകങ്ങൾ അറിവിൻ്റെയും സംസ്കാരത്തിൻ്റെയും ഭണ്ഡാരം

                                </h1>
                                <p className="lead fw-normal text-white-50 mb-4 text-justify">
                                    വിജ്ഞാനപ്രധാനമായ വായനയ്ക്ക് നല്ല പുസ്തകങ്ങൾ വേണം. മലയാള ഭാഷയേയും അതിൻ്റെ പൈതൃക സംസ്കാരത്തേയും കുറിച്ച് പഠിക്കാനും പ്രചരിപ്പിക്കാനും അതുവഴി, കല, ഭാഷ, സംസ്കാരം എന്നിവയിലെ മുല്യവത്തായ വസ്തുതകളെ ആലേഖനംചെയ്ത് സൂക്ഷിക്കാനും ഉയിർമൊഴി എന്നും പ്രയത്നിക്കുന്നു
                                </p>
                                <div className="d-grid gap-3 d-sm-flex justify-content-sm-center justify-content-xl-start">
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-xxl-6 text-center">
                            <Swiper
                                modules={[Autoplay, EffectFade]}
                                effect="fade" // ✅ Enable fade effect
                                fadeEffect={{ crossFade: true }} // ✅ Smoother crossfade
                                speed={2000} // ✅ Adjust this for "Slow" transition (2000ms = 2s)
                                autoplay={{
                                    delay: 3000,
                                    disableOnInteraction: false
                                }}
                                loop={true}
                            >
                                {bannerImage.map((banner) => (
                                    <SwiperSlide>
                                        <img src={IMG_BASE_URL + "banner/" + banner.image} className='header-poster' />
                                    </SwiperSlide>
                                ))}
                            </Swiper>

                        </div>
                    </div>
                </div>
            </header >
        </>
    )
}
